import Spinner from '@carvana/ds-spinner';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterLoadingScreen } from '|/helpers/loading-screens';
import { isNativeWebview } from '|/helpers/native';
import useLoadTimeTracking from '|/hooks/use-load-time-tracking';
import styles from './loading.module.css';

const defaultProps = {
  title: '',
  hideTitle: false,
  subtext: null as string | null,
  timeout: 750,
  small: false,
  label: null as string | null
};

const Loading: React.FC<Partial<typeof defaultProps>> = (props = {}) => {
  useLoadTimeTracking();
  useRegisterLoadingScreen();
  const location = useLocation();

  const { title, subtext, hideTitle, timeout, label } = props;

  const [show, setShow] = useState(false);

  const shouldHideSpinner = isNativeWebview && location.pathname.includes('/next-step');

  const displayLoading = () => {
    setShow(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      displayLoading();
    }, timeout);

    return () => {
      setShow(false);
      clearTimeout(timer);
    };
  }, [timeout]);

  if (shouldHideSpinner) {
    return null;
  }

  return (
    <div className={`${styles.container} ${show ? styles.show : ''}`}>
      {show && (
        <div className={styles.loadingWrapper}>
          {!hideTitle && title && <h1 className={styles.title}>{title}</h1>}
          {/* Spread conditionally: ds-spinner builds its svg props with
              Object.assign, so an explicit aria-label={undefined} overwrites
              its own "Loading" default and leaves the region unnamed. */}
          <Spinner size={57} {...(label ? { 'aria-label': label } : {})} />
          {subtext && <p className={styles.subtext}>{subtext}</p>}
        </div>
      )}
    </div>
  );
};

export default Loading;
